import { Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-trmnl-page',
  standalone: true,
  imports: [RouterLink, FormsModule],
  templateUrl: './trmnl-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './trmnl-page.component.scss'
})
export class TrmnlPageComponent {

  // Scorrendo, la barra sale a filo del bordo (top 0): lo spazio sopra di lei
  // mostrava il contenuto che passava. Stessa logica della home.
  scrolled = false;

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 8;
  }

  contactName    = '';
  contactPhone   = '';
  contactMsg     = '';
  contactSending = false;
  contactStatus: 'idle' | 'ok' | 'error' = 'idle';

  private contactOpenedAt = Math.floor(Date.now() / 1000);

  constructor(private http: HttpClient) {}

  sendContact(e: Event): void {
    e.preventDefault();
    if (!this.contactName.trim() || !this.contactMsg.trim() || this.contactSending) return;

    this.contactSending = true;
    this.contactStatus  = 'idle';

    this.http.post<{ ok: boolean }>('/php/api/contact.api.php', {
      name:    this.contactName.trim(),
      phone:   this.contactPhone.trim(),
      message: this.contactMsg.trim(),
      website: '',
      _t:      this.contactOpenedAt,
    }).subscribe({
      next: () => {
        this.contactStatus   = 'ok';
        this.contactSending  = false;
        this.contactName     = '';
        this.contactPhone    = '';
        this.contactMsg      = '';
        this.contactOpenedAt = Math.floor(Date.now() / 1000);
      },
      error: () => {
        this.contactStatus  = 'error';
        this.contactSending = false;
      }
    });
  }
}
